function ConfirmPasswordInputField({ handleValidation, handlePasswordChange, confirmPasswordValue, confirmPasswordError }) {
  return (
    <>
        <div className="text-danger message alert text-center">{confirmPasswordError}</div>

        <div className="input-field form-group my-3 message alert text-center ">
          <span className="ico-label"><i className="icomoon-icon icon-lock"></i></span>
          <input type="password" required="required" value={confirmPasswordValue} placeholder="تأكيد كلمة المرور" onChange={handlePasswordChange} onKeyUp={handleValidation} name="confirmPassword" className="form-control" />
          <div class="required">*</div>
        </div>
    </>
  )
}
export default ConfirmPasswordInputField;